module.exports = __webpack_public_path__ + "static/media/IAP_SplitPink@3x.3f3174eb.png";